import PropTypes from 'prop-types'
import React, { useState } from 'react'
// import { Chip } from '@mui/material';
// import BusinessDetailsHeader from './BusinessDetailsHeader';
import profileImage from '../../css/images/business-profile-image.png'
import fleetBusinessProfileImage from '../../css/images/Fleet-business-profile.svg'
// import { Typography } from '@mui/material'
// import { Link } from 'react-router-dom'
import CreateBusinessProfileForm from './CreateBusinessProfileForm'
// import FleetPlusButtonCode from '../../Pages/ProfilePage_new/BusinessUpdateProfileSubSections/FleetPlusButtonCode/FleetPlusButtonCode'
// import ErrorHandle from '../ErrorHandle'
// import { ProfileApis } from '../../API/Login/ProfileApi'

export default function CreateBusinessProfile({ profileInfo }) {
    const [createBusinessProfileMode, setCreateBusinessProfileMode] = useState(false)
    return (
        <main className="main users chart-page p-0" id="skip-target">
            <div className="profile-bg">
                <div className="business-cover-image">
                    <div className="container-fluid"></div>
                </div>
                <div className="container-fluid py-3 ">
                    <div className="align-items-start d-flex justify-content-between mb-5 flex-wrap">
                        <div>
                            <div className="d-flex flex-wrap">
                                <div className="image-holder-main position-relative">
                                    <div className="image-holder overflow-hidden position-relative">
                                        <img
                                            src={profileImage}
                                            alt="profileImage"
                                            height={160}
                                            width={160}
                                            style={{ objectFit: 'cover' }}
                                        />
                                    </div>
                                </div>
                                <div className="px-4 my-4 my-lg-0">
                                    <img alt="" src={fleetBusinessProfileImage} />

                                    <h4 className="mt-2">
                                        Business Name
                                    </h4>
                                    <p className="mb-0 small text-muted">
                                        No tag line added
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="shadow-sm p-4 rounded-4 me-4 bg-white bg-white bg-white">

                        </div>
                    </div>
                    {/* <BusinessDetailsHeader businessProfileData={[]} /> */}
                    <div className="row">
                        <div className="col-md-12">
                            {!createBusinessProfileMode ? <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
                                {/* <h5 className="fw-bold mb-3">{obj[data][0]}</h5> */}

                                <div className="text-center">
                                    <p className="text-muted">Add Your Business Details to Create your Business Profile</p>
                                    <button className="btn-upload " onClick={() => setCreateBusinessProfileMode(true)}>
                                        {/* <Typography
                                            component={Link}
                                            to="/pro/createbusinessprofile"
                                            className=""
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M12 5V19M5 12H19"
                                                    stroke="#fff"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                ></path>
                                            </svg>
                                        </Typography> */}
                                        {' '}
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M12 5V19M5 12H19"
                                                stroke="#fff"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                            </div> :
                                <CreateBusinessProfileForm setCreateBusinessProfileMode={setCreateBusinessProfileMode} />}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

CreateBusinessProfile.propTypes = {
    profileInfo: PropTypes.object,
}